export default "__VITE_ASSET__QndhqwIf__"